/* PilotstoriesArt cookie banner (sections/psa-cookie-banner.liquid) with Shopify's Customer Privacy API.
   The choice is saved with window.Shopify.customerPrivacy.setTrackingConsent, so Shopify pixels and apps follow it.
   Code that needs consent waits in <template data-psa-consent="analytics|marketing"> and is added to the page
   (scripts re-created so they run) only once that consent is "yes": on page load for returning visitors,
   or right after the visitor agrees. Nothing is ever loaded before a choice.
   The password page has no storefront token, so Shopify cannot save the choice there ("Server error"). The choice is
   then kept in this browser (localStorage "psa-consent-local"), the banner closes, and our own code follows it; Shopify's
   pixels stay off. On a later page where Shopify can save it, the kept choice is handed to Shopify once. */
(function () {
  'use strict';

  var root = document.getElementById('PsaCookie');
  if (!root) return;
  var bar = root.querySelector('[data-psa-cookie-bar]');
  // While the bar is open, its height goes into --psa-cookie-h so the phones' add-to-cart bar sits above it (7 Oct 2026).
  if (bar && window.ResizeObserver) new ResizeObserver(function () {
    document.documentElement.style.setProperty('--psa-cookie-h', bar.hidden ? '0px' : bar.offsetHeight + 'px');
  }).observe(bar);
  var dlg = document.getElementById('PsaCookieDialog');
  var api = null;
  var LOCAL = 'psa-consent-local';

  function localChoice() {
    try { return JSON.parse(window.localStorage.getItem(LOCAL) || 'null'); } catch (e) { return null; }
  }
  function consent() {
    var c = (api && api.currentVisitorConsent && api.currentVisitorConsent()) || {};
    if (!c.analytics && !c.marketing) {
      var l = localChoice();
      if (l) return { analytics: l.analytics ? 'yes' : 'no', marketing: l.marketing ? 'yes' : 'no' };
    }
    return c;
  }
  window.psaConsent = consent; // the newsletter box (psa-theme.js) keeps its longer memory only with marketing consent

  function inject(purpose) {
    document.querySelectorAll('template[data-psa-consent="' + purpose + '"]:not([data-psa-done])').forEach(function (tpl) {
      tpl.setAttribute('data-psa-done', '');
      var frag = tpl.content.cloneNode(true);
      frag.querySelectorAll('script').forEach(function (old) {
        var s = document.createElement('script');
        Array.prototype.forEach.call(old.attributes, function (a) { s.setAttribute(a.name, a.value); });
        s.async = old.hasAttribute('async');
        s.text = old.textContent;
        old.parentNode.replaceChild(s, old);
      });
      document.body.appendChild(frag);
    });
  }

  function apply() {
    var c = consent();
    if (c.analytics === 'yes') inject('analytics');
    if (c.marketing === 'yes') inject('marketing');
  }

  function save(analytics, marketing) {
    if (!api) return;
    // Marketing withdrawn: forget the newsletter box's longer memory (psa-theme.js, key "psa-nl").
    if (!marketing) { try { window.localStorage.removeItem('psa-nl'); } catch (e) {} }
    // Preferences cookies (e.g. remembered country) follow the analytics choice; the privacy policy names only the two purposes.
    api.setTrackingConsent({ analytics: analytics, marketing: marketing, preferences: analytics }, function (res) {
      if (res && res.error) {
        try { window.localStorage.setItem(LOCAL, JSON.stringify({ analytics: analytics, marketing: marketing, at: Date.now() })); } catch (e) {}
      } else {
        try { window.localStorage.removeItem(LOCAL); } catch (e) {}
      }
      bar.hidden = true;
      if (dlg && window.psaCloseDialog) window.psaCloseDialog(dlg);
      apply();
    });
  }

  function syncBoxes() {
    var c = consent();
    root.querySelectorAll('input[data-psa-consent]').forEach(function (box) {
      box.checked = c[box.getAttribute('data-psa-consent')] === 'yes';
    });
  }

  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-psa-consent-all]')) save(true, true);
    else if (e.target.closest('[data-psa-consent-none]')) save(false, false);
    else if (e.target.closest('[data-psa-consent-save]')) {
      save(!!root.querySelector('#PsaConsentAnalytics:checked'), !!root.querySelector('#PsaConsentMarketing:checked'));
    }
  });
  if (dlg) dlg.addEventListener('psa:dialog-open', syncBoxes);
  // Consent given elsewhere (another tab, checkout) also unlocks the code.
  document.addEventListener('visitorConsentCollected', apply);

  if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') return;
  window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
    if (error || !window.Shopify.customerPrivacy) return;
    api = window.Shopify.customerPrivacy;
    var c = consent();
    var undecided = !c.analytics && !c.marketing;
    if (undecided || root.hasAttribute('data-psa-editor')) bar.hidden = false;
    apply();
    // A choice kept in this browser (see above): hand it to Shopify where it can be saved
    var l = localChoice(), s = api.currentVisitorConsent();
    if (l && !s.analytics && !s.marketing) {
      api.setTrackingConsent({ analytics: !!l.analytics, marketing: !!l.marketing, preferences: !!l.analytics }, function (res) {
        if (!res || !res.error) { try { window.localStorage.removeItem(LOCAL); } catch (e) {} }
      });
    }
  });
})();
